"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DhsInstallerForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const ReactDOM = require("react-dom");
const app_1 = require("app");
const formik_1 = require("formik");
const react_google_recaptcha_1 = require("react-google-recaptcha");
const InstallerFormConfig_1 = require("../InstallerFormConfig");
const dhsInstallerHelpers_1 = require("../helpers/dhsInstallerHelpers");
const FormikConfig_1 = require("Views/Partials/Components/FormikFields/FormikConfig");
const DhsInstallerForm = props => {
    const [formState, setFormState] = React.useState(null);
    const recaptchaRef = React.createRef();
    const validationSchema = (0, InstallerFormConfig_1.getDhsInstallerValidationSchema)(props);
    const RecaptchaComponent = react_google_recaptcha_1.default;
    const gtmData = (() => {
        const { items, control } = props;
        const { titleText } = items.specificFields;
        return {
            control: control,
            label: items.submitLabel,
            title: titleText,
        };
    })();
    const { apiUrl, additionalFormData, reCaptchaSiteKey, items: { specificFields }, renderMessage, renderSpinner, pageId, bypassRecaptchaKey, } = props;
    let initialFormState = {
        firstName: '',
        lastName: '',
        company: '',
        companyType: '',
        numberOfEmployees: '',
        jobFunction: '',
        email: '',
        country: '',
        postalZipCode: '',
        language: '',
        consentCheckbox: false,
    };
    const recaptchaBypass = (0, FormikConfig_1.recaptchaKeyGuard)(bypassRecaptchaKey);
    // Update Form initial values
    initialFormState = (0, dhsInstallerHelpers_1.updateInitialFormValues)(props, initialFormState);
    // Reset Recaptcha manually
    (0, app_1.useRecaptchaReset)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: "dhs-installer-main", children: [(0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: initialFormState, validationSchema: validationSchema, enableReinitialize: true, validateOnBlur: false, validateOnMount: true, onSubmit: (values) => {
                    const state = Object.assign(Object.assign({}, formState), values);
                    recaptchaBypass
                        ? (0, FormikConfig_1.submitForm)(state, apiUrl, additionalFormData, gtmData, specificFields, renderMessage, renderSpinner, '', pageId)
                        : (0, dhsInstallerHelpers_1.performReCaptchaCheck)(recaptchaRef, renderMessage, specificFields);
                    setFormState(state);
                }, children: ({ values, errors, touched, isSubmitting, isValidating }) => {
                    (0, dhsInstallerHelpers_1.handleGtmValidationError)(isValidating, isSubmitting, gtmData, errors, values);
                    return ((0, jsx_runtime_1.jsx)(formik_1.Form, { children: (0, FormikConfig_1.renderFormItems)(props, errors, touched, values, gtmData, InstallerFormConfig_1.installerSignUpFormConfig) }));
                } }), !recaptchaBypass &&
                ReactDOM.createPortal((0, jsx_runtime_1.jsx)(RecaptchaComponent, { className: "newsletter-recaptcha recaptcha-mounted", ref: recaptchaRef, size: "invisible", sitekey: reCaptchaSiteKey, onChange: recaptchaToken => (0, FormikConfig_1.submitForm)(formState, apiUrl, additionalFormData, gtmData, specificFields, renderMessage, renderSpinner, recaptchaToken, pageId), onErrored: () => (0, dhsInstallerHelpers_1.handleError)(gtmData, renderMessage, specificFields) }), document.body)] }));
};
exports.DhsInstallerForm = DhsInstallerForm;
